import 'arrive'
import $ from 'jquery'

let timer = null;

document.arrive('.oc-search-box', {existing: true}, function(){

  var $container = $(this);
  var $item = $container.find('input[name="search"]');
  var $results = $container.find('.oc-results');


  $item.on('keyup', function(){
    clearTimeout(timer);
    timer = setTimeout(function(){

      var code = $item.val();

      const request = new XMLHttpRequest();
      const url = ajax_object.ajax_url;

      request.open('POST', url, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  
      request.onload = function() {
  
        if (this.status >= 200 && this.status < 400) {
          $results.html(this.responseText)
        }
  
      }
  
      request.onerror = function() {}
      request.send('action=oc_load_search&code=' + code);

    }, 450);
  })

});